import { Navigate, useLocation } from "react-router-dom";
import PaymentResult from "../Pages/protected/PaymentResult";
import { getPaymentResultViolation } from "../utils/paymentResultSecurity";

/**
 * Only exact /payment-result (optional ?query) — rejects pipe-concatenated paths.
 */
const PaymentResultRoute = () => {
  const { pathname, search } = useLocation();
  const violation = getPaymentResultViolation(pathname, search);

  if (violation) {
    const lang = localStorage.getItem("lang") || "az";
    return <Navigate to={`/${lang}/`} replace />;
  }

  return <PaymentResult />;
};

export default PaymentResultRoute;
